export const DF_DELAY = 1500, DF_DURATION = 1500
// what is the problem?
// export const DF_TRANSITION = d3.transition().delay(DF_DELAY).duration(DF_DURATION)


// WEBPACK FOOTER //
// ./src/components/visualizations/animated/default-design.ts